module.exports = __webpack_public_path__ + "img/Instagram.256d164a.png";